const GUP_APP_REDIRECT_URL = ''
const VUE_APP_HOST_BACKEND_URL = ''
const VUE_APP_HOST_URL = ''
const GUP_DATA_BACKEND_WEB_URL = ''
const LANDING_PAGE_URL = ''
const VERSION_YEAR = '2021'
const VERSION_NUMBER = '0.0.1.0'
const COOKIE_EXPIRE_DAYS = 1
const HTTP_REQUEST_TIMEOUT: number = 30 * 1000
const SIGN_OUT_TIMEOUT: number = 20 * 60
const SIGN_OUT_NOTIFY_TIMEOUT: number = 15 * 60
const GTM_ID = ''
const GTM_ENABLED = false
const ANNOUNCEMENT_URL = ''

export default {
  /**
   * @description GUP App redirect url
   */
  GUP_APP_REDIRECT_URL,

  /**
   * @description CRM service backend
   */
  VUE_APP_HOST_BACKEND_URL,

  /**
   * @description VUE App service url
   */
  VUE_APP_HOST_URL,

  /**
   * @description GUP 數據後台位置
   */
  GUP_DATA_BACKEND_WEB_URL,

  /**
   * @description Landing page url
   */
  LANDING_PAGE_URL,

  /**
   * @description version year
   */
  VERSION_YEAR,

  /**
   * @description version number
   */
  VERSION_NUMBER,

  /**
   * @description Cookie expire days
   */
  COOKIE_EXPIRE_DAYS,

  /**
   * @description Timeout (Millionseconds) for Axios
   */
  HTTP_REQUEST_TIMEOUT,

  /**
   * @description Auto-SignOut timeout (seconds)
   */
  SIGN_OUT_TIMEOUT,

  /**
   * @description Show notify when the countdown reach this value (seconds)
   */
  SIGN_OUT_NOTIFY_TIMEOUT,

  /**
   * @description GTM Id
   */
  GTM_ID,

  /**
   * @description is GTM enable
   */
  GTM_ENABLED,

  ANNOUNCEMENT_URL,
}
